import axios from 'axios';
import { urlsServices } from '@/config/urls';

let httpUrl = `${urlsServices.GETWAY}api/publicidade`;

export const getAllPublicidades = async () => {
  return await axios.get(`${httpUrl}/list`).then((response) => response);
};

export const getPublicidadeById = async (id) => {
  return await axios.get(`${httpUrl}/${id}`);
};

export const updatePublicidadeSituacao = async (id, situacao) => {
  return await axios.put(`${httpUrl}/${id}/situacao/${situacao}`);
};

export const deletePublicidade = async (id) => {
  return await axios.delete(`${httpUrl}/${id}`);
};

export const createPublicidade = async (data) => {
  return await axios.post(`${httpUrl}/`, data);
};
